module.exports = __webpack_public_path__ + "media/bootstrap-icons/braces-fc7d277b.svg";